function Success() {
  return (
    <main className="page page--success">
      <section className="success-card">
        <h2 className="section-title">Order Placed Successfully</h2>
        <p className="success-note">Your meal is being prepared and is on the way.</p>
      </section>
    </main>
  );
}

export default Success;
